<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import {
  bgFillQuaternary,
  textTertiary,
} from '@nora-monorepo/ui-shared';

defineProps<{ fillFrame?: boolean }>();
const { t } = useI18n();
</script>

<template>
  <div class="flex justify-center items-center h-full" :class="fillFrame ? bgFillQuaternary : ''">
    <div
      class="max-w-full max-h-full flex justify-center items-center flex-col p-2"
      :class="[bgFillQuaternary, textTertiary, fillFrame ? 'w-full h-full' : 'w-32 h-28 rounded-xl']"
    >
      <span class="mi delete md-36 mx-auto" />
      <span class="text-xs text-center mt-1">{{ t('attachments.attachmentDeleted') }}</span>
    </div>
  </div>
</template>
